module.exports = __webpack_public_path__ + "img/map_toilet_b1@2x.1325fcf0.png";